<template>
    <b-card
    v-if="show"
    :title="message"
    tag="article"
    style="max-width: 20rem;"
    class="mb-2"
  >
    <!-- <b-card-text>
        {{message}}
    </b-card-text> -->
  </b-card>
</template>

<script>
export default {
    name: "Certification",
    data() {
        return {
            PassToken: this.$route.query.Token,
            timer: '',
            message: '',
            show: false,
            apiAccountCertification: (data) => this.userRequest.post("/API/Default/AccountCertification", data),
        }
    },
    created() {
        this.FunctionToken(this.checkAccountCertification, {"PassToken": this.PassToken})
    },
    beforeDestroy() {
      clearTimeout(this.timer);
    },
    methods: {
        checkAccountCertification(data) {
            this.apiAccountCertification(data)
            .then((res)=>{
                const json = JSON.parse(res.data)
                // console.log(json)
                if(json.Status){
                    this.message = "帳號已開通，將自動轉接至登入畫面"
                    this.timer = setTimeout(this.goToLoginPage, 5000);
                }
                else
                {
                    this.message = json.Data
                }
                this.show = true
            })
            .catch((err)=> {
                console.log(err)
            });
        },
        goToLoginPage()
        {
            // this.$router.go('/login')
            this.$router.push('Login')
        }
    }

}
</script>